import * as MAILINGJOBS from './mailingJobs.constants';
import { MailingJobDefinitionDto } from '../../models';

/** LOAD */
export function loadMailingJobs() {
    return { type: MAILINGJOBS.MAILING_JOBS_LOAD };
}

export function loadMailingJobsSuccess(data: MailingJobDefinitionDto[]) {
    return { type: MAILINGJOBS.MAILING_JOBS_LOAD_SUCCESS, payload: data };
}

export function loadMailingJobsError(error: any) {
    return { type: MAILINGJOBS.MAILING_JOBS_LOAD_ERROR, payload: error };
}


/** ADD */
export function addMailingJobs(targetMailingJobs: MailingJobDefinitionDto[]) {
    return { type: MAILINGJOBS.MAILING_JOBS_ADD, payload: targetMailingJobs };
}

export function addMailingJobsSuccess(targetMailingJobs: MailingJobDefinitionDto[]) {
    return { type: MAILINGJOBS.MAILING_JOBS_ADD_SUCCESS, payload: targetMailingJobs };
}

export function addMailingJobsError(error: any) {
    return { type: MAILINGJOBS.MAILING_JOBS_ADD_ERROR, payload: error };
}


/** UPDATE */
export function updateMailingJobs(targetMailingJobs: MailingJobDefinitionDto[]) {
    return { type: MAILINGJOBS.MAILING_JOBS_UPDATE, payload: targetMailingJobs };
}

export function updateMailingJobsSuccess(targetMailingJobs: MailingJobDefinitionDto[]) {
    return { type: MAILINGJOBS.MAILING_JOBS_UPDATE_SUCCESS, payload: targetMailingJobs };
}

export function updateMailingJobsError(error: any) {
    return { type: MAILINGJOBS.MAILING_JOBS_UPDATE_ERROR, payload: error };
}


/** DELETE */
export function deleteMailingJobs(guids: string[]) {
    return { type: MAILINGJOBS.MAILING_JOBS_DELETE, payload: guids };
}

export function deleteMailingJobsSuccess(MailingJobs: MailingJobDefinitionDto[]) {
    return { type: MAILINGJOBS.MAILING_JOBS_DELETE_SUCCESS, payload: MailingJobs };
}

export function deleteMailingJobsError(error: any) {
    return { type: MAILINGJOBS.MAILING_JOBS_DELETE_ERROR, payload: error };
}